import { render } from "./HomeByWsxy.vue?vue&type=template&id=29e21f62&scoped=true"
import script from "./HomeByWsxy.vue?vue&type=script&lang=js"
export * from "./HomeByWsxy.vue?vue&type=script&lang=js"

import "./HomeByWsxy.vue?vue&type=style&index=0&id=29e21f62&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-29e21f62"

export default script